module.exports = __webpack_public_path__ + "media/images/huda_01-b9533e1c8c7e8d1ffe15b3bc8fd91f37.jpg";